$ = require('jquery')

module.exports =
	init: ->
		$(document)
			.on('click', '.tr-clickable', (e) ->
				e.preventDefault()

				window.location = $(this).find('a').first().attr('href')
			)



/** WEBPACK FOOTER **
 ** ./src/js/components/tr-clickable.coffee
 **/